import React from "react";
import PropTypes from "prop-types"; // Import đúng package
import { lazy } from "react";
import classNames from "classnames/bind";
import styles from "./Spinner.module.css"; // Giả sử bạn sử dụng cùng file CSS

// Lazy load Wheel component
const Wheel = lazy(() =>
  import("react-custom-roulette").then((module) => ({ default: module.Wheel }))
);

// Memoize WheelComponent để ngăn re-render không cần thiết
const WheelComponent = React.memo(
  ({ mustStartSpinning, prizeNumber, wheelData, onStopSpinning }) => {
    const cx = classNames.bind(styles);

    return (
        <Wheel
          mustStartSpinning={mustStartSpinning}
          prizeNumber={prizeNumber}
          data={wheelData}
          backgroundColors={[
            "#00cc99",
            "#1abc9c",
            "#55efc4",
            "#ff7675",
            "#74b9ff",
            "#a29bfe",
            "#ffeaa7",
            "#fd79a8",
          ]}
          textColors={["#ffffff"]}
          fontSize={16}
          outerBorderWidth={2}
          innerBorderWidth={2}
          radiusLineWidth={2}
          outerBorderColor="#2c3e50"
          innerBorderColor="#2c3e50"
          radiusLineColor="#2c3e50"
          onStopSpinning={onStopSpinning}
            disableInitialAnimation={true} // Tắt animation khởi tạo ban đầu
        />
    );
  }
);

// Định nghĩa PropTypes hoặc kiểm tra props nếu cần
WheelComponent.propTypes = {
  mustStartSpinning: PropTypes.bool.isRequired,
  prizeNumber: PropTypes.number.isRequired,
  wheelData: PropTypes.arrayOf(
    PropTypes.shape({
      option: PropTypes.string,
    })
  ).isRequired,
  onStopSpinning: PropTypes.func.isRequired,
};

export default WheelComponent;